// Amazon Associates API service
// For now, this uses manual product data and simple affiliate link generation
// Later can be enhanced with Amazon Product Advertising API

// ── Centralized product catalog ────────────────────────────────────────────────
const PRODUCT_CATALOG = [
  {
    asin: 'B003AYWIU8',
    title: 'Jonathan Green Black Beauty Ultra Grass Seed',
    price: '$39.99', rating: 4.4,
    category: 'grass_seed',
    keywords: ['seed', 'grass', 'overseed', 'seeding', 'germination', 'lawn seed'],
  },
  {
    asin: 'B0822WM7YH',
    title: 'The Andersons PGF Complete 16-4-8 Fertilizer',
    price: '$45.99', rating: 4.6,
    category: 'fertilizer',
    keywords: ['fertilizer', 'fertilize', 'nutrition', 'feed', 'nitrogen', 'npk', 'humic'],
  },
  {
    asin: 'B084TSNR79',
    title: 'MySoil Soil Test Kit – Complete Nutrient Analysis',
    price: '$29.95', rating: 4.3,
    category: 'soil_testing',
    keywords: ['soil', 'test', 'ph', 'nutrient', 'analysis', 'organic matter'],
  },
  {
    asin: 'B08SMNFTDK',
    title: 'EarthWay 2600A-PLUS Professional Broadcast Spreader',
    price: '$89.99', rating: 4.5,
    category: 'tools',
    keywords: ['spreader', 'broadcast', 'application', 'granular', 'apply'],
  },
  {
    asin: 'B0050DW2M6',
    title: 'Scotts GrubEx1 Season Long Grub Killer',
    price: '$24.99', rating: 4.2,
    category: 'pest_control',
    keywords: ['grub', 'pest', 'insect', 'control', 'prevention', 'beetle', 'larvae'],
  },
  {
    asin: 'B000HCRM4S',
    title: 'Bonide Chickweed, Clover & Oxalis Killer',
    price: '$16.99', rating: 4.1,
    category: 'weed_control',
    keywords: ['weed', 'herbicide', 'killer', 'broadleaf', 'selective', 'clover', 'crabgrass', 'pre-emergent', 'postemergent'],
  },
  {
    asin: 'B075R7BNXV',
    title: 'Scotts DiseaseEx Lawn Fungicide',
    price: '$19.99', rating: 4.2,
    category: 'disease_control',
    keywords: ['disease', 'fungus', 'fungicide', 'brown patch', 'dollar spot', 'mold'],
  },
  {
    asin: 'B07CZ864Y9',
    title: 'Rachio Wi-Fi Smart Sprinkler Controller',
    price: '$199.99', rating: 4.6,
    category: 'watering',
    keywords: ['sprinkler', 'irrigation', 'watering', 'smart', 'controller', 'water'],
  },
  {
    asin: 'B001D1FFZA',
    title: "Grampa's Weeder – Original Stand-Up Weed Puller Tool",
    price: '$32.99', rating: 4.3,
    category: 'tools',
    keywords: ['weed', 'puller', 'weeding', 'dandelion', 'tool', 'mechanical', 'hand pull'],
  },
  {
    asin: 'B08N4QR9C3',
    title: 'HiHydro 12-Inch Stainless Steel Soil Probe',
    price: '$19.99', rating: 4.4,
    category: 'soil_testing',
    keywords: ['soil', 'probe', 'sampling', 'test', 'core', 'aerator'],
  },
];

// Section title patterns → which product categories are relevant
const SECTION_CATEGORY_MAP = [
  { pattern: /pre.?emergent|crabgrass/i,       cats: ['weed_control', 'tools'] },
  { pattern: /seed|overseed|spring seed/i,      cats: ['grass_seed', 'tools'] },
  { pattern: /fertiliz/i,                       cats: ['fertilizer', 'tools'] },
  { pattern: /weed/i,                           cats: ['weed_control', 'tools'] },
  { pattern: /pest|grub|insect/i,               cats: ['pest_control'] },
  { pattern: /disease|fungus|fungicide/i,        cats: ['disease_control'] },
  { pattern: /water|irrigation/i,               cats: ['watering'] },
  { pattern: /soil/i,                           cats: ['soil_testing'] },
  { pattern: /mow|mainten/i,                    cats: ['tools'] },
  { pattern: /aerat|dethatch|scarif/i,           cats: ['tools'] },
];

const PRIORITY_WEIGHT = { critical: 4, high: 2, medium: 1, low: 0.5 };

const SEASONAL_DEFAULTS = {
  spring: ['B003AYWIU8', 'B0822WM7YH', 'B084TSNR79', 'B08SMNFTDK'],
  summer: ['B0050DW2M6', 'B000HCRM4S', 'B07CZ864Y9', 'B075R7BNXV'],
  fall:   ['B003AYWIU8', 'B0822WM7YH', 'B084TSNR79', 'B001D1FFZA'],
  winter: ['B084TSNR79', 'B0822WM7YH', 'B003AYWIU8', 'B08SMNFTDK'],
};

class AmazonAPIService {
  constructor() {
    // You'll need to replace these with your actual Amazon Associates credentials
    this.associateTag = process.env.REACT_APP_AMAZON_ASSOCIATE_TAG || 'your-associate-tag-20';
    this.baseAmazonUrl = 'https://amazon.com';
  }

  // Generate affiliate link for a given ASIN
  generateAffiliateLink(asin, customUrl = null) {
    if (customUrl) {
      // Use custom URL if provided (for specific product pages)
      return `${customUrl}?th=1&linkCode=ll1&tag=${this.associateTag}&linkId=6f177955691d400abbf98c28a1a9ccca&language=en_US&ref_=as_li_ss_tl`;
    }
    
    // Standard ASIN-based link with full affiliate parameters
    return `https://www.amazon.com/dp/${asin}?th=1&linkCode=ll1&tag=${this.associateTag}&linkId=6f177955691d400abbf98c28a1a9ccca&language=en_US&ref_=as_li_ss_tl`;
  }

  // Generate local product image URL with fallback
  generateImageUrl(asin) {
    // Use local images stored in public/images/products/ with ASIN as filename
    // Supported formats: jpg, jpeg, png, webp
    // Fallback to default-product.svg if no image found
    return `/images/products/${asin}.jpg`;
  }

  // Get fallback image URL
  getFallbackImageUrl() {
    return '/images/products/default-product.svg';
  }

  // Search for products based on keywords (mock implementation)
  // In production, this would use Amazon Product Advertising API
  async searchProducts(keywords, category = null) {
    try {
      // Return real Amazon products with affiliate links
      const realResults = this.getRealProductResults(keywords, category);
      
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 500));
      
      return {
        success: true,
        products: realResults,
        totalResults: realResults.length
      };
    } catch (error) {
      console.error('Amazon API search error:', error);
      return {
        success: false,
        products: [],
        error: error.message
      };
    }
  }

  // Get product details by ASIN (mock implementation)
  async getProductDetails(asin) {
    try {
      // Mock product details - replace with actual API call
      const mockProduct = {
        asin: asin,
        title: `Product ${asin}`,
        price: '$24.99',
        primeEligible: true,
        rating: 4.3,
        reviewCount: 234,
        imageUrl: `https://via.placeholder.com/150x150?text=${asin}`,
        affiliateUrl: this.generateAffiliateLink(asin),
        features: ['Feature 1', 'Feature 2', 'Feature 3']
      };

      await new Promise(resolve => setTimeout(resolve, 300));

      return {
        success: true,
        product: mockProduct
      };
    } catch (error) {
      console.error('Amazon API product details error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // Real Amazon products with affiliate links
  getRealProductResults(keywords, category) {
    const realProducts = {
      'soil test': [
        {
          asin: 'B084TSNR79',
          title: 'MySoil Soil Test Kit - Complete Nutrient Analysis & Fertilizer Recommendations',
          price: '$29.95',
          rating: 4.3,
          reviewCount: 1847,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B084TSNR79'),
          affiliateUrl: this.generateAffiliateLink('B084TSNR79'),
          category: 'soil_testing',
          features: ['Professional lab analysis', 'Custom fertilizer recommendations', 'pH and nutrient testing', 'Organic matter analysis']
        },
        {
          asin: 'B08N4QR9C3',
          title: 'HiHydro 12-Inch Stainless Steel Soil Probe with 2 Sample Bags',
          price: '$19.99',
          rating: 4.4,
          reviewCount: 892,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B08N4QR9C3'),
          affiliateUrl: this.generateAffiliateLink('B08N4QR9C3'),
          category: 'soil_testing'
        }
      ],
      'fertilizer spreader': [
        {
          asin: 'B08SMNFTDK',
          title: 'EarthWay 2600A-PLUS Professional Broadcast Spreader',
          price: '$89.99',
          rating: 4.5,
          reviewCount: 2156,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B08SMNFTDK'),
          affiliateUrl: this.generateAffiliateLink('B08SMNFTDK'),
          category: 'tools',
          features: ['Professional grade', 'Even distribution', 'Large hopper capacity', 'Pneumatic tires']
        }
      ],
      'lawn fertilizer': [
        {
          asin: 'B0822WM7YH',
          title: 'The Andersons Professional PGF Complete 16-4-8 Fertilizer with Humic DG',
          price: '$45.99',
          rating: 4.6,
          reviewCount: 1234,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B0822WM7YH'),
          affiliateUrl: this.generateAffiliateLink('B0822WM7YH'),
          category: 'fertilizer',
          features: ['Professional grade', 'Slow release', 'Includes humic acid', 'Complete nutrition']
        },
        {
          asin: 'B09B4555L9',
          title: 'The Andersons Professional PGF 16-0-8 Fertilizer with Humic DG',
          price: '$42.99',
          rating: 4.5,
          reviewCount: 987,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B09B4555L9'),
          affiliateUrl: this.generateAffiliateLink('B09B4555L9'),
          category: 'fertilizer'
        }
      ],
      'grass seed': [
        {
          asin: 'B003AYWIU8',
          title: 'Jonathan Green Black Beauty Ultra Grass Seed (7 lb)',
          price: '$39.99',
          rating: 4.4,
          reviewCount: 2341,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B003AYWIU8'),
          affiliateUrl: this.generateAffiliateLink('B003AYWIU8'),
          category: 'grass_seed',
          features: ['Drought tolerant', 'Disease resistant', 'Dense growth', 'Premium seed mix']
        }
      ],
      'grub control': [
        {
          asin: 'B0050DW2M6',
          title: 'Scotts GrubEx1 Season Long Grub Killer',
          price: '$24.99',
          rating: 4.2,
          reviewCount: 1567,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B0050DW2M6'),
          affiliateUrl: this.generateAffiliateLink('B0050DW2M6'),
          category: 'pest_control'
        }
      ],
      'weed control': [
        {
          asin: 'B000HCRM4S',
          title: 'Bonide Chickweed, Clover & Oxalis Killer',
          price: '$16.99',
          rating: 4.1,
          reviewCount: 1123,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B000HCRM4S'),
          affiliateUrl: this.generateAffiliateLink('B000HCRM4S'),
          category: 'weed_control'
        },
        {
          asin: 'B001D1FFZA',
          title: "Grampa's Weeder – Original Stand-Up Weed Puller Tool",
          price: '$32.99',
          rating: 4.3,
          reviewCount: 2234,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B000HCRM4S'),
          affiliateUrl: this.generateAffiliateLink('B001D1FFZA'),
          category: 'tools'
        }
      ],
      'lawn tools': [
        {
          asin: 'B07G2V1DHD',
          title: 'Corona Tools GT 3234 Reach 7-Tine Extended Rake',
          price: '$28.99',
          rating: 4.4,
          reviewCount: 876,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B07G2V1DHD'),
          affiliateUrl: this.generateAffiliateLink('B07G2V1DHD'),
          category: 'tools'
        }
      ],
      'sprinkler system': [
        {
          asin: 'B07CZ864Y9',
          title: 'Rachio Wi-Fi Smart Sprinkler Controller (8-Zone)',
          price: '$199.99',
          rating: 4.6,
          reviewCount: 3456,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B07CZ864Y9'),
          affiliateUrl: this.generateAffiliateLink('B07CZ864Y9'),
          category: 'watering',
          features: ['WiFi enabled', 'Weather intelligence', 'Easy scheduling', 'Works with Alexa']
        }
      ],
      'disease control': [
        {
          asin: 'B075R7BNXV',
          title: 'Scotts DiseaseEx Lawn Fungicide',
          price: '$19.99',
          rating: 4.2,
          reviewCount: 1345,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B075R7BNXV'),
          affiliateUrl: this.generateAffiliateLink('B075R7BNXV'),
          category: 'disease_control'
        }
      ],
      'sprayer': [
        {
          asin: 'B0071D0EZK',
          title: 'Ortho Dial N Spray Hose-End Sprayer',
          price: '$14.99',
          rating: 4.3,
          reviewCount: 2145,
          primeEligible: true,
          imageUrl: this.generateImageUrl('B0071D0EZK'),
          affiliateUrl: this.generateAffiliateLink('B0071D0EZK'),
          category: 'tools'
        }
      ]
    };

    // Find matching products with flexible keyword matching
    const lowerKeywords = keywords.toLowerCase();
    for (const [key, products] of Object.entries(realProducts)) {
      // Check if task text contains any part of the product key or vice versa
      if (lowerKeywords.includes(key) || key.split(' ').some(word => lowerKeywords.includes(word))) {
        return products;
      }
    }

    // Return default fertilizer products if no match
    return realProducts['lawn fertilizer'] || [];
  }

  // Return the shared product catalog (for AffiliateStore etc.)
  getProductCatalog() {
    return PRODUCT_CATALOG.map(p => ({
      ...p,
      imageUrl:     this.generateImageUrl(p.asin),
      affiliateUrl: this.generateAffiliateLink(p.asin),
    }));
  }

  // Score and rank products against actual month sections + priorities
  getRecommendedProducts(sections = [], season = '', maxCount = 4) {
    const scores = {};

    sections.forEach(section => {
      const sectionTitle = section.title || '';
      const tasks = section.tasks || [];

      // Determine relevant categories from the section title
      const sectionCats = new Set();
      SECTION_CATEGORY_MAP.forEach(({ pattern, cats }) => {
        if (pattern.test(sectionTitle)) cats.forEach(c => sectionCats.add(c));
      });

      tasks.forEach(task => {
        const weight = PRIORITY_WEIGHT[task.priority] || 1;
        const taskText = (task.text || '').toLowerCase();

        PRODUCT_CATALOG.forEach(product => {
          let gain = 0;

          // +3 per task if the section title maps to this product's category
          if (sectionCats.has(product.category)) gain += 3;

          // +2 per keyword match in task text
          product.keywords.forEach(kw => {
            if (taskText.includes(kw.toLowerCase())) gain += 2;
          });

          if (gain > 0) {
            scores[product.asin] = (scores[product.asin] || 0) + gain * weight;
          }
        });
      });
    });

    // Sort all scored products
    const scored = PRODUCT_CATALOG
      .filter(p => scores[p.asin] > 0)
      .map(p => ({ ...p, _score: scores[p.asin] }))
      .sort((a, b) => b._score - a._score);

    // Fall back to seasonal defaults when nothing matched
    if (scored.length === 0) {
      const asins = (SEASONAL_DEFAULTS[season?.toLowerCase()] || SEASONAL_DEFAULTS.spring).slice(0, maxCount);
      return PRODUCT_CATALOG
        .filter(p => asins.includes(p.asin))
        .sort((a, b) => asins.indexOf(a.asin) - asins.indexOf(b.asin))
        .map(p => ({ ...p, imageUrl: this.generateImageUrl(p.asin), affiliateUrl: this.generateAffiliateLink(p.asin) }));
    }

    // Pick top results, preferring one product per category for variety
    const result = [];
    const usedCats = new Set();

    for (const p of scored) {
      if (result.length >= maxCount) break;
      if (!usedCats.has(p.category)) { result.push(p); usedCats.add(p.category); }
    }
    // Fill remaining slots with next-best if under maxCount
    for (const p of scored) {
      if (result.length >= maxCount) break;
      if (!result.find(r => r.asin === p.asin)) result.push(p);
    }

    return result.map(({ _score, ...p }) => ({
      ...p,
      imageUrl:     this.generateImageUrl(p.asin),
      affiliateUrl: this.generateAffiliateLink(p.asin),
    }));
  }

  // Track affiliate link clicks (for analytics)
  trackAffiliateClick(asin, taskContext, userZone) {
    try {
      // Track click in Google Analytics if available
      if (window.gtag) {
        window.gtag('event', 'affiliate_click', {
          event_category: 'amazon_affiliate',
          event_label: asin,
          custom_parameter_1: taskContext,
          custom_parameter_2: userZone
        });
      }

      // Store in localStorage for local tracking
      const clicks = JSON.parse(localStorage.getItem('affiliateClicks') || '[]');
      clicks.push({
        asin,
        taskContext,
        userZone,
        timestamp: new Date().toISOString()
      });
      
      // Keep only last 100 clicks
      if (clicks.length > 100) {
        clicks.splice(0, clicks.length - 100);
      }
      
      localStorage.setItem('affiliateClicks', JSON.stringify(clicks));
    } catch (error) {
      console.error('Error tracking affiliate click:', error);
    }
  }
}

// Create singleton instance
const amazonAPI = new AmazonAPIService();

export default amazonAPI;